import styled from 'styled-components';
import {
  colorsVariables,
  zIndicesVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';

export const HeaderWave = styled.svg`
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  z-index: ${zIndicesVariables.wave};
  path {
    fill: ${colorsVariables.PINEAPPLE_500};
  }
`;
